import { PATHS } from '@core/routes';

export function isOmsTabSelected(pathname: string, tabPath: string): boolean {
  const absolute = `${PATHS.oms}/${tabPath}`;
  return pathname === absolute || pathname.startsWith(`${absolute}/`);
}
